import JustValidate from 'just-validate'

const settings = {
  errorFieldCssClass: 'is-invalid',
  errorLabelCssClass: 'input-error',
  errorLabelStyle: {
    color: '#C9211B'
  },
  focusInvalidField: true,
  lockForm: false
}

type Rule = {
  rule?: string
  value?: number|boolean|string
  validator?: (value: string, fields: any) => boolean
  errorMessage?: string
}

type inputRule = {
  id: string
  rules: Rule[]
}

const allRules: {
  [key: string]: Rule
} = {
  email: {
    rule: 'email',
    errorMessage: 'Email is invalid!'
  },
  number: {
    rule: 'number'
  }
}

const initValidate = (formEl: HTMLElement, callback = false) => {
  const formId = `form#${formEl.id}`
  const inputs = Array.prototype.slice.call(formEl.querySelectorAll('input:not([type=hidden]), select, textarea'))
  if (inputs.length) {
    const validate = new JustValidate(formId, settings)
    const newRules = inputs.map((input: HTMLInputElement) => getValidateRule(input))
    newRules.forEach((rule: inputRule) => rule.rules.length > 0 && validate.addField(rule.id, rule.rules))
    if (!callback) {
      validate.onSuccess((event) => {
        if (formEl.onsubmit) {
          formEl.onsubmit(<SubmitEvent>event)
        }
      })
    }
    return validate
  }
}

const addRuleConfirm = (rules: Rule[], input: HTMLInputElement) => {
  const confirmField = input.getAttribute('data-confirm')
  const confirmMessage = input.getAttribute('data-confirm-message')
  if (confirmField && confirmMessage) {
    rules.push({
      validator: (value, fields) => {
        if (fields[confirmField] && fields[confirmField].elem) {
          const confirmFieldValue = fields[confirmField].elem.value
          return value === confirmFieldValue
        }
        return true
      },
      errorMessage: confirmMessage
    })
  }
  return rules
}

const getValidateRule = (input: HTMLInputElement) => {
  const inputName = input.getAttribute('aria-label') || 'Field'
  const rules: inputRule = {
    id: `#${input.id}`,
    rules: []
  }
  if (input) {
    if (input.required) {
      rules.rules.push({
        rule: 'required',
        errorMessage: `${inputName} is required`
      })
    }
    if (input.type === 'email') {
      rules.rules.push(allRules.email)
    }
    rules.rules = addRuleConfirm(rules.rules, input)
  }
  return rules
}

export { initValidate }
